import React, { ReactNode } from "react";
import { cx } from "@jugl-web/utils";
import { InteractiveContainer } from "../../primitives/InteractiveContainer";

interface SideMenuLayoutItem {
  id: string;
  label: string;
  icon?: ReactNode;
  endSlotIcon?: ReactNode;
}

export interface SideMenuLayoutProps {
  items: SideMenuLayoutItem[];
  selectedItem: string;
  onItemClick: (item: SideMenuLayoutItem) => void;
}

export const SideMenuLayout: React.FC<SideMenuLayoutProps> = ({
  items,
  onItemClick,
  selectedItem,
}) => (
  <div className="flex flex-col gap-4">
    {items.map((item) => {
      const isSelected = selectedItem === item.id;

      return (
        <InteractiveContainer
          className={cx(
            "hover:bg-grey-100 flex h-[54px] items-center gap-3 overflow-hidden rounded-2xl px-4 transition-colors",
            isSelected && "bg-[#EFF8FF] hover:bg-[#EFF8FF]"
          )}
          key={item.id}
          onClick={() => onItemClick(item)}
        >
          {item.icon && <div className="flex shrink-0">{item.icon}</div>}
          <span
            className={cx(
              "text-dark font-secondary grow truncate text-sm",
              isSelected && "font-medium "
            )}
            title={item.label}
          >
            {item.label}
          </span>
          {item.endSlotIcon && (
            <div className="flex shrink-0">{item.endSlotIcon}</div>
          )}
        </InteractiveContainer>
      );
    })}
  </div>
);
